import React from 'react';
import PropTypes from 'prop-types';

import '../sass/BoardgameHeader.sass';

const BoardgameHeader = ({ title, imageUrl, backgroundPosition }) => {
  return (
    <header className="sg-boardgame-header relative h-2/3-screen">
      <div
        className="absolute flex flex-col justify-end inset-0 w-full h-2/3-screen md:rounded-t bg-no-repeat bg-cover"
        style={{ backgroundPosition, backgroundImage: `url("${imageUrl}")` }}
      >
        <div className="sg-boardgame-header__overlay absolute inset-0"></div>
        <h1 className="z-10 px-4 md:px-8 mb-4 font-black text-white font-serif text-3xl">{ title }</h1>
      </div>
    </header>
  );
};

BoardgameHeader.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  backgroundPosition: PropTypes.string,
};

BoardgameHeader.defaultProps = {
  backgroundPosition: 'center top',
};

export default BoardgameHeader;
